import axios from 'axios';
import { CLIENT_REST_ROUTE } from '../routes/constants';
import { logError } from './utils';

const getUrl = () => `${CLIENT_REST_ROUTE.LOCALIZATION_DATA}`;

export const getLocalizationData = (userId) =>
    axios
        .post(getUrl(), { userId })
        .then(({ data }) => data)
        .catch((error) => {
            logError(`Failed to fetch getLocalizationData "${userId}"`, { error });
            throw error;
        });
